import { About } from "@/components/triarch/About";
import { FinalCTA } from "@/components/triarch/FinalCTA";

export default function ProtocolPage() {
  return (
    <div className="pt-24 sm:pt-28">
      <About />
      <FinalCTA />
    </div>
  );
}
